const portalConfiguration = {
  tabPannelDetails: {
    tab1: "Form Management",
    tab2: "Landing Page",
    tab3:"General Portal",
    tab4: "Disclaimer",
    tab5: "FAQ",
  },
  disclaimerPageDetails:{
    headerEnglish: "Header",
    headerFrench: "Header (French)",
    bodyEnglish: "Body",
    bodyFrench: "Body (French)",
    headerFrenchReq: "Header (French) is Required",
    headerReq: "Header is Required",
    bodyReq: "Body is Required",
    bodyFrenchReq: "Body (French) is Required",

  },
  landingPageDetails: {
    imageSectinTitle: "Hero Image Section",
    addClaimSection: "Add Claim Section",
    viewManagaeSection: "View & Manage Claims Section",
    viewPublicDocuments: "View Public Documents Section",
    pageHeaderSection: "Page Header & Footer Section",
    contactSection: "Contact Section",
    headerEnglish: "Header",
    footer: "Footer",
    headerFrench: "Header (French)",
    footerFrench: "Footer (French)",
    buttonTextEnglish: "Button Text",
    buttonTextFrench: "Button Text (French)",
    bodyEnglish: "Body",
    bodyFrench: "Body (French)",
    link: "Link",
    contactUs: "Contact Us Link",
    headerReq: "Header is Required",
    footerReq: "Footer is Required",
    headerFrenchReq: "Header (French) is Required",
    footerFrenchReq: "Footer (French) is Required",
    buttonTextReq: "Button Text is Required",
    buttonTextFrenchReq: "Button Text (French) is Required",
    bodyReq: "Body is Required",
    bodyFrenchReq: "Body (French) is Required",
    linkReq: "Link is Required",
    contactUsReq: "Contact Us Link is Required",
  },
  createForm: "Build New Form",
  tableTitle: "Forms",
  tableDescription: "Descriptive text that describes your page or content.",
  columnDetails: {
    column1: "Form Name",

    column2: "Form Type",

    column3: "Status",

    column4: "Description ",

    column5: "Due Date",

    column6: "Published Date",
  },
  createFormTitle: "Create a new Form",
  createFormSubTitle: "Form Configuration",
  createFormSubDescription:
    "Descriptive text that describes your page or content.",
  formLabels: {
    formName: "Form Name (English)",
    formNameFrench: "Form Name (French)",
    formDescription: "Form Description (English)",
    formDescriptionFrench: "Form Description (French)",
    formType: "Form Type",
    formActionType: "Form Action Type",
    formStatus: "Form Status",
    formStage: "Form Stage",
    formDueDate: "Form Due Date",
    time: "Time",
    dueSubmission: "Past Due Submission",
    formPublish: "Form Publishing Logic",
    formReview: "Allow users to review form details before submission",
    requestUser: "Request users to sign the document and upload",
  },
  publishLabels: {
    label1: "Select Type",
    label2: "Previous in-progress forms will not be invalidated",
    label3: "Invalidate all in-progress forms and replace with new version",
  },
  validationMessages: {
    formNameReq: "Form Name is required",
    formType: "Form Type is required",
    stageReq: "Stage is required",
    dueSubmissionReq: "Past Due Submission is required",
    formStatusReq: "Form Status is required",
  },
  bannerDetails: {
    title: "Form Name",
    lable1: "Status",
  },
  formTypeLabels: {
    label1: "Select Type",
    label2: "Claim Form",
    label3: "Action Form",
    label4: "Other Form",
  },
  actionTypeLabels: {
    label1: "Select Type",
    label2: "Amend Form",
    label3: "Dispute Form",
    label4: "Withdraw Form",
  },
  pastSubmissinLabels: {
    label: "Select Type",
    label1: "Hide form, but allow in-progress submissions",
    label2: "Hide form, no submissions allowed",
    label3: "Warn portal users on deadline only",
  },
  formStatusLabels: {
    label1: "Draft",
    label2: "Published for testing",
    label3: "Publish",
    label4: "Hidden",
  },
  defaultOptionType: "Select Type",
  formTabPannel: {
    tab1: "Summary",
    tab2: "Form Setup",
  },
  GeneralPortal:{
    formLabels:{
      label1:"Case Name",
      label2:"Case Name (French)",
      label3:"Case URL",
      label4:"Portal Status",
      label5:"Allow users to sign in",
    },
    validationMessages:{
      caseNameReq:"Case Name is required",
      caseNameFrenchReq:"Case Name (French) is required",
      caseURLReq:"Case URL is required",
    }
  },
  FAQConfig:{
    formLabels:{
      label1:"Body",
      label2:"Body(French)"
    },
    validationMessages:{
      bodyReq:"Body is required",
      bodyFrenchReq:"Body(French) is required",
    }
  }
};

export default portalConfiguration;
